import React from "react";
import summaryStyle from "./summaryStyle";
import Grid from "@mui/material/Grid";
import { translate } from "../../../../services/translations/translations";
import Typography from "@mui/material/Typography";
import { isInsurerPartnered } from "../../../../services/productService";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";
import { Box } from "@mui/material";

type InsuranceDataProps = {
  formData: Record<string, any>;
  product: AbstractCase;
  title: string;
};

const InsuranceData = ({ formData, product, title }: InsuranceDataProps) => {

  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h5"}>{title}</Typography>
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"name"} sx={summaryStyle.scrollToAnchor} />
        Versicherung
      </Grid>
      <Grid size={12}>
        {product.caseInsurance.insurer.name}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"insurancePolicyNumber"} sx={summaryStyle.scrollToAnchor} />
        Versicherungsnummer
      </Grid>
      <Grid size={12}>
        {formData.caseInsurance.insurancePolicyNumber}
      </Grid>
      {!isInsurerPartnered(product) && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"caseReferenceNumber"} sx={summaryStyle.scrollToAnchor} />
            Schadennummer
          </Grid>
          <Grid size={12}>
            {formData.caseInsurance.caseReferenceNumber}
          </Grid>
        </>
      )}
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"policyHolderType"} sx={summaryStyle.scrollToAnchor} />
        Selbst oder mitversichert
      </Grid>
      <Grid size={12}>
        {translate(`${product.name}.caseInsurance.policyHolderType.options.${formData.caseInsurance.policyHolderType}.label`, formData)}
      </Grid>
      {formData.caseInsurance.policyHolderType === "familyMember" && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"gender"} sx={summaryStyle.scrollToAnchor} />
            Anrede Versicherter
          </Grid>
          <Grid size={12}>
            {formData.caseInsurance.policyHolder.gender === "male" ? "Herr" : "Frau"}
          </Grid>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"givenName"} sx={summaryStyle.scrollToAnchor} />
            Vorname Versicherter
          </Grid>
          <Grid size={12}>
            {formData.caseInsurance.policyHolder.givenName}
          </Grid>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"familyName"} sx={summaryStyle.scrollToAnchor} />
            Nachname Versicherter
          </Grid>
          <Grid size={12}>
            {formData.caseInsurance.policyHolder.familyName}
          </Grid>
        </>
      )}
    </>
  );
};

export default InsuranceData;
